/**
 * This file contains the Js code for Single Podcasts.
 * Contains all custom manipulations and functionalities for Podcast Video and Audio.
 */

/**
 * The Podcast object handles the functionality related to the podcast video player.
 * It sets up event listeners for controlling the play button and video playback.
 */
const Podcast = {

	/**
	 * Initializes the podcast functionality by setting up event listeners
	 * when the DOM content is fully loaded.
	 */
	init() {
		document.addEventListener( 'DOMContentLoaded', () => {
			this.setupEventListeners();
		} );
	},

	/**
	 * Sets up the event listeners for various interactions in the podcast.
	 * Currently, it sets up listeners related to video playback.
	 */
	setupEventListeners() {
		this.setupEventListenersForVideo();
	},

	/**
	 * Sets up event listeners for the video element and play icon button.
	 * - Handles play and pause events on the video.
	 * - Toggles the visibility of the play button based on the video state.
	 * - Handles the play button click to start the video playback.
	 */
	setupEventListenersForVideo() {

		const podcastVideoWrapper = document.querySelector( '.podcast-video-wrapper' );
		if ( undefined === podcastVideoWrapper || ! podcastVideoWrapper ) {
			return;
		}

		const videoPlayIcon = podcastVideoWrapper.querySelector( 'button.play-icon' );
		if ( undefined === videoPlayIcon || ! videoPlayIcon ) {
			return;
		}

		const podcastVideo = podcastVideoWrapper.querySelector( 'video.podcast-video' );
		if ( undefined === podcastVideo || ! podcastVideo ) {
			return;
		}

		podcastVideo.addEventListener( 'play', () => {
			videoPlayIcon.classList.add( 'hide' );
		} );

		videoPlayIcon.addEventListener( 'click', ( event ) => {
			if ( undefined === podcastVideo || ! podcastVideo ) {
				return;
			}

			podcastVideo.play();
		} )
	}
}

export default Podcast;
